"use strict";
/**
 * @module "ethpm"
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthPM = void 0;
const session = __importStar(require("./session"));
/**
 * This module provides the external interface for configuring an EthPM
 * session object.
 *
 * Usage:
 * ```javascript
 * import EthPM from "ethpm";
 *
 * ```
 */
var EthPM;
(function (EthPM) {
    /**
     * Configure EthPM with specified Node modules to load for various
     * services
     *
     * Example Usage:
     * ```javascript
     * import EthPM from "ethpm";
     * const builder = EthPM.configure({
     *   manifests: "ethpm/manifests/v3",
     *   storage: "ethpm/storage/ipfs",
     *   registries: "ethpm/registries/web3"
     * })
     * ```
     *
     * EthPM.js will `require()` the specified modules from your project's
     * `node_modules/` folder.
     */
    function configure(config) {
        return new session.Builder(config);
    }
    EthPM.configure = configure;
})(EthPM = exports.EthPM || (exports.EthPM = {}));
